import { createSlice } from "@reduxjs/toolkit";

const selectItemDrawerMenuSlice = createSlice({
    name: "selectItemDrawerMenu",
    initialState: {
        selectedTitle: "",
        selectedId: null,
    },
    reducers: {
        setSelectedTitle: (state, action) => {
            state.selectedTitle = action.payload;
        },
        setSelectedId: (state, action) => {
            state.selectedId = action.payload;
        },
    },
});

export const { setSelectedTitle, setSelectedId } = selectItemDrawerMenuSlice.actions;
export default selectItemDrawerMenuSlice.reducer;
